import _ from 'lodash'

import { AdUnitSizeDTO } from 'features/globalSetup/features/viewport'
import {
  MediaTypeRefresherAttributesSchema,
  MediaTypeRefreshersKind,
  MediaTypeRefreshersSchema,
  MediaTypeRefresherViewportAttributeSchema,
} from './schema'

import type {
  MediaTypeRefresherBaseDTO,
  MediaTypeRefresherDTO,
} from 'features/inventory/ad-unit/api/types/mediaTypeRefresherDTO'
import type { MediaTypeRefreshersDTO } from 'features/inventory/ad-unit/api/types/mediaTypeRefreshersDTO'

const adUnitSizeToSchema = (size: AdUnitSizeDTO): string =>
  Array.isArray(size) ? `${size[0]}x${size[1]}` : size

const adUnitSizesToSchema = (sizes: AdUnitSizeDTO[] = []): string[] => sizes.map(adUnitSizeToSchema)

export const mediaTypeRefresherDefaultAttributeToSchema = (
  defaultAttribute?: MediaTypeRefresherBaseDTO,
): MediaTypeRefresherAttributesSchema => ({
  additionalSizes: adUnitSizesToSchema(defaultAttribute?.additionalSizes),
  id: defaultAttribute?.id,
  removeSizes: adUnitSizesToSchema(defaultAttribute?.removeSizes),
  updatedAt: defaultAttribute?.updatedAt ? new Date(defaultAttribute.updatedAt) : undefined,
})

export const mediaTypeRefresherViewportAttributesToSchema = (
  viewportAttributes: MediaTypeRefresherDTO[],
): MediaTypeRefreshersSchema['viewportAttributes'] =>
  viewportAttributes
    .filter(
      (
        attribute: MediaTypeRefresherDTO,
      ): attribute is MediaTypeRefresherDTO & {
        viewport: NonNullable<MediaTypeRefresherDTO['viewport']>
      } => attribute.viewport !== null,
    )
    .map(
      (
        attribute: MediaTypeRefresherDTO & {
          viewport: NonNullable<MediaTypeRefresherDTO['viewport']>
        },
      ): MediaTypeRefresherViewportAttributeSchema => ({
        ...mediaTypeRefresherDefaultAttributeToSchema(attribute),
        updatedAt: new Date(attribute.updatedAt),
        viewport: {
          minimumWidth: attribute.viewport.minimumWidth,
          name: attribute.viewport.name,
          viewportId: attribute.viewport.id,
        },
        viewportId: attribute.viewport.id,
      }),
    )

export const mediaTypeRefreshersToSchema = (
  mediaTypeRefreshers?: MediaTypeRefreshersDTO | null,
): MediaTypeRefreshersSchema => {
  const kind: MediaTypeRefreshersKind =
    mediaTypeRefreshers?.ignoreViewportRefresherAttributes === false ? 'viewports' : 'default'

  const mediaTypeRefreshersSchema: MediaTypeRefreshersSchema = {
    defaultAttribute: mediaTypeRefresherDefaultAttributeToSchema(
      mediaTypeRefreshers?.defaultAttribute,
    ),
    kind,
    newViewportId: undefined,
    viewportAttributes: mediaTypeRefresherViewportAttributesToSchema(
      mediaTypeRefreshers?.viewportAttributes ?? [],
    ),
  }

  return kind === 'default'
    ? _.omit(mediaTypeRefreshersSchema, 'newViewportId')
    : mediaTypeRefreshersSchema
}
